var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangleWarning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46758 2.89626C7.13977 1.70125 8.86031 1.70125 9.53251 2.89626L14.4383 11.6177C15.0976 12.7898 14.2507 14.238 12.9059 14.238H3.0942C1.74943 14.238 0.902449 12.7898 1.56174 11.6177L6.46758 2.89626ZM8.8791 11.6007C8.8791 12.0863 8.4855 12.4799 7.99997 12.4799C7.51443 12.4799 7.12083 12.0863 7.12083 11.6007C7.12083 11.1152 7.51443 10.7216 7.99997 10.7216C8.4855 10.7216 8.8791 11.1152 8.8791 11.6007ZM7.99996 4.56765C7.51443 4.56765 7.12083 4.96125 7.12083 5.44678V8.08419C7.12083 8.56972 7.51443 8.96332 7.99996 8.96332C8.4855 8.96332 8.8791 8.56972 8.8791 8.08419V5.44678C8.8791 4.96125 8.4855 4.56765 7.99996 4.56765Z",
    fill: "#F08E0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleWarning);
export default __webpack_public_path__ + "static/media/triangle-warning.6afc171b18a8240b03ed5534f0a5a7bf.svg";
export { ForwardRef as ReactComponent };